import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import Tooltip from 'components/Tooltip'
import messages from './messages'
import styles from './BusinessZoneCount.scss'

const BusinessZoneCount = ({
  intl,
  type,
  counts = {
    currentZone: 0,
    total: 0,
  },
}) => (
  <span className={styles.container}>
    <Tooltip title={intl.formatMessage(messages.tooltips.currentZone, { type })}>
      <span className={styles.zone}>{counts.currentZone}</span>
    </Tooltip>
    <span className={styles.separator}>/</span>
    <Tooltip title={intl.formatMessage(messages.tooltips.total, { type })}>
      <span className={styles.total}>{counts.total >= 1000 ? '1000+' : counts.total}</span>
    </Tooltip>
  </span>
)

BusinessZoneCount.propTypes = {
  intl: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  counts: PropTypes.shape({
    currentZone: PropTypes.number,
    total: PropTypes.number,
  }),
}

export default injectIntl(BusinessZoneCount)
